import { apiSlice } from '../../api-slice';

export const genericApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createGeneric: builder.mutation({
            query: (data) => ({
                url: 'generics',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Generic'],
        }),

        getGenerics: builder.query({
            query: (params) => {
                return {
                    url: 'generics',
                    method: 'GET',
                    params,
                };
            },
            providesTags: ['Generic'],
            keepUnusedDataFor: 600,
        }),

        updateGeneric: builder.mutation({
            query: (data) => ({
                url: `generics/${data.id}`,
                method: 'PUT',
                body: {
                    name: data.name,
                },
            }),
            invalidatesTags: ['Generic'],
        }),

        deleteGeneric: builder.mutation({
            query: (id) => ({
                url: `generics/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['Generic'],
        }),
    }),
});

export const {
    useCreateGenericMutation,
    useGetGenericsQuery,
    useUpdateGenericMutation,
    useDeleteGenericMutation,
} = genericApi;
